import { Controller } from "@hotwired/stimulus"

// This controller is used to manage integer filters.
// It's expected to be used with the following markup:
// <div data-controller="filters--integer-filter"
//      data-filters--integer-filter-name-value="opens"
//      data-filters--integer-filter-comparison-value="any"
//      data-filters--integer-filter-filter-value="*">
// ...
// </div>
export default class extends Controller {
  static get targets() {
    return ["button", "radioButton", "moreThanInput", "lessThanInput"]
  }
  static get values() {
    return { name: String, comparison: String, filter: String }
  }

  apply() {
    let checkedRadioButton = this.radioButtonTargets.find((radioButton) => radioButton.checked)
    const dropdown = bootstrap.Dropdown.getInstance(this.buttonTarget)

    if (checkedRadioButton.value === "*") {
      this.filterValue = "*"
      this.comparisonValue = "any"
    } else if (checkedRadioButton.value === "lt") {
      this.filterValue = this.lessThanInputTarget.value
      this.comparisonValue = "lt"
    } else if (checkedRadioButton.value === "gt") {
      this.filterValue = this.moreThanInputTarget.value
      this.comparisonValue = "gt"
    }

    this.dispatchFilterEvent()
    dropdown.hide()
  }

  clear() {
    this.filterValue = ""

    this.dispatchFilterEvent()
  }

  dispatchFilterEvent() {
    if (this.filterValue === "") {
      this.dispatch("filter", { detail: { name: this.nameValue, values: this.filterValue } })
      return
    }

    if (this.comparisonValue === "any") {
      this.dispatch("filter", { detail: { name: this.nameValue, values: "*" } })
    } else if (this.filterValue) {
      let filterValues = `${this.comparisonValue}:${this.filterValue}`
      this.dispatch("filter", { detail: { name: this.nameValue, values: filterValues } })
    }
  }
}
